<template>
    <ReportsList/>
</template>
<script>
import ReportsList from '../../components/reports/ReportsList';

export default {
  components: {
    ReportsList,
  },
};
</script>
